import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, Box } from '@mui/material';

const ResetPasswordDialog = ({
  open,
  onClose,
  coach,
  newPassword,
  confirmPassword,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  error
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Reset Password</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Set a new password for <strong>{coach?.coachName}</strong>
        </DialogContentText>
        <TextField
          label="New Password"
          type="password"
          fullWidth
          variant="outlined"
          margin="dense"
          value={newPassword}
          onChange={onNewPasswordChange}
        />
        <TextField
          label="Confirm Password"
          type="password"
          fullWidth
          variant="outlined"
          margin="dense"
          value={confirmPassword}
          onChange={onConfirmPasswordChange}
        />
        {error && <Box sx={{ color: 'red', mt: 1 }}>{error}</Box>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={onSubmit} variant="contained" color="primary">
          Update Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordDialog;
